import { useState, useEffect, useRef, useContext } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { Icon } from "../../../../components/icons/Icon";
import { IconMap } from "../icons/IconMap";
import DropdownItem from "../../../../components/navigation/DropdownItem";

// icons
import { List, CalendarDays, Map } from "lucide-react";

// import { Icon } from "../../components/icons/Icon";
// import { chevronRight, chevronLeft, cog, info, blank } from "../icons/appIcons";
// import { logout, user } from "../icons/authIcons";

// const FilterDropupMenu = ({ open, setOpen, taleId, ...otherProps }) => {
const FilterDropupMenu = ({ open, setOpen, activeFilters, onToggleFilter }) => {
  const [activeMenu, setActiveMenu] = useState("main");
  const [menuHeight, setMenuHeight] = useState(null);

  // const navigate = useNavigate();
  //   const { isLoggedIn } = useContext(AuthContext);
  // const [isOpen, setIsOpen] = useState(false);

  // const location = useLocation();
  // const prevKeyRef = useRef(location.key); // capture key on mount

  // useEffect(() => {
  //   if (location.key !== prevKeyRef.current) {
  //     prevKeyRef.current = location.key; // update for next time
  //     if (open) setOpen(false);
  //   }
  // }, [location.key, open, setOpen]);

  const toggleDropdown = (e) => {
    // e.preventDefault();
    setOpen(!open);
  };

  const primaryRef = useRef(null);
  // const secondaryRef = useRef(null);

  /**
   * Calculate height of dropdown menu
   * @param {*} node
   */
  function calcElementHeight(node) {
    const height = node.offsetHeight;
    setMenuHeight(height);
  }

  // Get color class based on active state
  const getColorClass = (type, originalColor) => {
    return activeFilters[type] ? originalColor : "neutral";
  };

  return (
    <div
      id="filter_dd_menu"
      className="left-drop-up"
      role="menu"
      style={{ height: menuHeight }}
    >
      <CSSTransition
        nodeRef={primaryRef}
        in={activeMenu === "main"} //this cannot be array, breaks submenu navigation
        timeout={500}
        classNames="dd-menu-primary"
        unmountOnExit
        onEnter={calcElementHeight}
      >
        <div className="dd-menu" ref={primaryRef}>
          <DropdownItem
            as="link"
            to={`#`}
            // onSelect={(e) => {
            //   e.preventDefault();
            //   handleToggleFilter("transportation");
            // }}
            onClick={() => onToggleFilter("transportation")}
            centerIcon={
              <div className="icon">
                <div
                  className={`svg round segment-path-icon ${getColorClass(
                    "transportation",
                    "blue"
                  )}`}
                >
                  <Icon
                    icon={IconMap["car"]}
                    size={24}
                    width={24}
                    height={24}
                    color="var(--surface)"
                  />
                </div>
              </div>
            }
            className="dd-item"
          ></DropdownItem>
          <DropdownItem
            as="link"
            to={`#`}
            onClick={() => onToggleFilter("accommodation")}
            // onSelect={(e) => {
            //   e.preventDefault();
            //   handleToggleFilter("accommodation");
            // }}
            centerIcon={
              <div className="icon">
                <div
                  className={`svg round segment-path-icon ${getColorClass(
                    "accommodation",
                    "brown"
                  )}`}
                >
                  <Icon
                    icon={IconMap["hotel"]}
                    size={24}
                    width={24}
                    height={24}
                    color="var(--surface)"
                  />
                </div>
              </div>
            }
            className="dd-item"
          ></DropdownItem>
          <DropdownItem
            as="link"
            to={`#`}
            onClick={() => onToggleFilter("activity")}
            // onSelect={(e) => {
            //   e.preventDefault();
            //   handleToggleFilter("activity");
            // }}
            centerIcon={
              <div className="icon">
                <div
                  className={`svg round segment-path-icon ${getColorClass(
                    "activity",
                    "green"
                  )}`}
                >
                  <Icon
                    icon={IconMap["hiking"]}
                    size={24}
                    width={24}
                    height={24}
                    color="var(--surface)"
                  />
                </div>
              </div>
            }
            className="dd-item"
          ></DropdownItem>
          <DropdownItem
            as="link"
            to={`#`}
            onClick={() => onToggleFilter("tracks")}
            // onSelect={(e) => {
            //   e.preventDefault();
            //   handleToggleFilter("tracks");
            // }}
            centerIcon={
              <div className="icon">
                <div
                  className={`svg round segment-path-icon ${getColorClass(
                    "tracks",
                    "black"
                  )}`}
                >
                  <Icon
                    icon={IconMap["tracks"]}
                    size={24}
                    width={24}
                    height={24}
                    color="var(--surface)"
                  />
                </div>
              </div>
            }
            className="dd-item"
          ></DropdownItem>
        </div>
      </CSSTransition>
    </div>
  );
};

export default FilterDropupMenu;
